import { ToothView } from '../../Enums/ToothView.enum';
import { Tooth48 } from './SurfaceDefinition/48.const';
import { Tooth47 } from './SurfaceDefinition/47.const';
import { Tooth46 } from './SurfaceDefinition/46.const';
import { Tooth45 } from './SurfaceDefinition/45.const';
import { Tooth44 } from './SurfaceDefinition/44.const';
import { Tooth43 } from './SurfaceDefinition/43.const';
import { Tooth42 } from './SurfaceDefinition/42.const';
import { Tooth41 } from './SurfaceDefinition/41.const';
import { Tooth31 } from './SurfaceDefinition/31.const';
import { Tooth32 } from './SurfaceDefinition/32.const';
import { Tooth33 } from './SurfaceDefinition/33.const';
import { Tooth34 } from './SurfaceDefinition/34.const';
import { Tooth35 } from './SurfaceDefinition/35.const';
import { Tooth36 } from './SurfaceDefinition/36.const';
import { Tooth37 } from './SurfaceDefinition/37.const';
import { Tooth38 } from './SurfaceDefinition/38.const';
import { Tooth18 } from './SurfaceDefinition/18.const';
import { Tooth28 } from './SurfaceDefinition/28.const';
import { Tooth27 } from './SurfaceDefinition/27.const';
import { Tooth26 } from './SurfaceDefinition/26.const';
import { Tooth25 } from './SurfaceDefinition/25.const';
import { Tooth24 } from './SurfaceDefinition/24.const';
import { Tooth23 } from './SurfaceDefinition/23.const';
import { Tooth22 } from './SurfaceDefinition/22.const';
import { Tooth21 } from './SurfaceDefinition/21.const';
import { Tooth11 } from './SurfaceDefinition/11.const';
import { Tooth12 } from './SurfaceDefinition/12.const';
import { Tooth13 } from './SurfaceDefinition/13.const';
import { Tooth14 } from './SurfaceDefinition/14.const';
import { Tooth15 } from './SurfaceDefinition/15.const';
import { Tooth16 } from './SurfaceDefinition/16.const';
import { Tooth17 } from './SurfaceDefinition/17.const';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../graphql/graphql';
import { Tooth51 } from './SurfaceDefinition/51.const';
import { Tooth52 } from './SurfaceDefinition/52.const';
import { Tooth53 } from './SurfaceDefinition/53.const';
import { Tooth54 } from './SurfaceDefinition/54.const';
import { Tooth55 } from './SurfaceDefinition/55.const';
import { Tooth61 } from './SurfaceDefinition/61.const';
import { Tooth62 } from './SurfaceDefinition/62.const';
import { Tooth63 } from './SurfaceDefinition/63.const';
import { Tooth64 } from './SurfaceDefinition/64.const';
import { Tooth65 } from './SurfaceDefinition/65.const';
import { Tooth71 } from './SurfaceDefinition/71.const';
import { Tooth72 } from './SurfaceDefinition/72.const';
import { Tooth73 } from './SurfaceDefinition/73.const';
import { Tooth74 } from './SurfaceDefinition/74.const';
import { Tooth75 } from './SurfaceDefinition/75.const';
import { Tooth81 } from './SurfaceDefinition/81.const';
import { Tooth82 } from './SurfaceDefinition/82.const';
import { Tooth83 } from './SurfaceDefinition/83.const';
import { Tooth84 } from './SurfaceDefinition/84.const';
import { Tooth85 } from './SurfaceDefinition/85.const';

// ILLUSTRATOR EXPORTS SVG LAYERS AS PATH OR POLYGONS - THAT CANT BE CONTROLLED, SO WE NEED TO SUPPORT BOTH OPTIONS
export enum ToothSurfaceDataType {
	PATH = 'PATH',
	POLYGON = 'POLYGON',
}

export type FractureKey = `${ToothFractureType},${ToothFracturePosition}`;

export interface ToothViewData {
	surfaces: Partial<
		Record<ToothSurface, { type: ToothSurfaceDataType; data: string }>
	>;
	fractures?: Partial<Record<FractureKey, string[]>>;
}
// LOWER TOOTH HAVE LINGUAL AND UPPER TOOTH HAVE PALATAL SO NEVER CANT HAVE BOTH IS ONE OR ANOTHER
export type ToothDataEntry =
	| {
			[ToothView.BUCCAL]: ToothViewData;
			[ToothView.INCISAL]: ToothViewData;
			[ToothView.PALATAL]: ToothViewData;
			[ToothView.LINGUAL]?: never;
	  }
	| {
			[ToothView.BUCCAL]: ToothViewData;
			[ToothView.INCISAL]: ToothViewData;
			[ToothView.LINGUAL]: ToothViewData;
			[ToothView.PALATAL]?: never;
	  };

export const ToothData: Record<number, ToothDataEntry> = {
	48: Tooth48,
	47: Tooth47,
	46: Tooth46,
	45: Tooth45,
	44: Tooth44,
	43: Tooth43,
	42: Tooth42,
	41: Tooth41,
	31: Tooth31,
	32: Tooth32,
	33: Tooth33,
	34: Tooth34,
	35: Tooth35,
	36: Tooth36,
	37: Tooth37,
	38: Tooth38,
	18: Tooth18,
	17: Tooth17,
	16: Tooth16,
	15: Tooth15,
	14: Tooth14,
	13: Tooth13,
	12: Tooth12,
	11: Tooth11,
	21: Tooth21,
	22: Tooth22,
	23: Tooth23,
	24: Tooth24,
	25: Tooth25,
	26: Tooth26,
	27: Tooth27,
	28: Tooth28,
	51: Tooth51,
	52: Tooth52,
	53: Tooth53,
	54: Tooth54,
	55: Tooth55,
	61: Tooth61,
	62: Tooth62,
	63: Tooth63,
	64: Tooth64,
	65: Tooth65,
	71: Tooth71,
	72: Tooth72,
	73: Tooth73,
	74: Tooth74,
	75: Tooth75,
	81: Tooth81,
	82: Tooth82,
	83: Tooth83,
	84: Tooth84,
	85: Tooth85,
};
